import React from 'react';
import videoSrc from './david_subway.mp4';
import './VideoBackground.css';

const VideoBackground = () => {
  const scrollToMusic = () => {
    document.getElementById('music-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="video-container">
      <video
        className="video-bg"
        src={videoSrc}
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="video-overlay" />
      <div className="video-content">
        <h1 className="hero-title">daarc</h1>
        <p className="hero-subtitle">atmospheric synthesis & electronic fvckery</p>
      </div>

      <button
        className="hero-play-btn"
        onClick={scrollToMusic}
        aria-label="Go to Music"
      >
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M8 5v14l11-7z"/>
        </svg>
      </button>
    </div>
  );
};

export default VideoBackground;
